<script setup lang="ts">
import { inject, onMounted, watch } from "vue";
import { useForm } from "@/helpers/composables/useForm";
import { string, object, } from "yup";
// import { route } from "ziggy-js";
import RothcoCta from "@/components/RothcoCta.vue";
import Recaptcha from "@/components/Recaptcha.vue";
import { useSettingsStore } from "@/store/settings";
import { storeToRefs } from "pinia";
import { usePage, Head } from "@inertiajs/vue3";
const settings = useSettingsStore()
let { user } = storeToRefs(settings)
let {toggleFlyout} = settings;
let route = inject('route')
const form = useForm({
    useInertia: true,
    inertiaAlias: 'CustomerService/OrderStatus',
    abortEarly: false,
    schema: object({
        orderId: string().required('Web Confirmation # or Order # is required'),
        email: string().email('Invalid email').required('Email is required'),
        captchaResponse: string().test({
            name: 'captchaResponse',
            message: 'Please complete the captcha',
            test: (value) => {
                if(user.value.user_id){
                    return true
                }
                return value != null && value != ''
            }
        })
    })
})

watch(() => form.errors, (newErrors, oldErrors) => {
    if (newErrors.login_errors && oldErrors.login_errors == null) {
        toggleFlyout({
            type: 'error',
            headline: "Error: ",
            message: newErrors.login_errors,
        })
    }
}, { deep: true })

</script>
<template>
    <div>
        <Head>
            <title>Order Status</title>
            <meta name="description" content="Get insights to your Rothco order." />
        </Head>
        <div class="order-statuses">
            <h1 role="heading" aria-level="1" class="title-xl">Order Status</h1>
            <form class="form" @submit.prevent="form.post(route('order.lookup'))">
                <div :aria-hidden="!form.errors.order" class="notification notification-error" v-show="form.errors.order">
                    <p class="paragraph-details"><strong>Error:</strong> {{ form.errors.order }}</p>
                </div>
                <div class="flex-row justify-between">
                    <div class="input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText 
                            :class="{
                                'invalid-state-input': form.errors.orderId
                            }"
                            aria-label="Order # / Web Confirmation # *"
                            aria-required="true"
                            placeholder="" id="orderId" v-model.lazy="form.orderId"/>
                            <label for="orderId">
                                <p class="paragraph-default">
                                    Order # / Web Confirmation # *
                                </p>
                            </label>
                        </div>
                        <div class="input-folder--support">
                            <p v-if="form.errors.orderId == null" class="input-support-text">
                                Order number can be found in your order confirmation email.
                            </p>
                            <p v-else id="orderId-error" class="input-support-text invalid-state">
                                {{ form.errors.orderId }}
                            </p>
                        </div>
                    </div>
                    <div class="input-folder">
                        <div class="input-folder--input">
                            <PrimeInputText 
                            :class="{
                                'invalid-state-input': form.errors.email
                            }"
                            aria-label="Email *"
                            aria-required="true"
                            placeholder="" id="email" v-model.lazy="form.email"/>
                            <label for="email">
                                <p class="paragraph-default">
                                    Email *
                                </p>
                            </label>
                        </div>
                        <div class="input-folder--support">
                            <p v-if="form.errors.email" id="email-error" class="input-support-text invalid-state">
                                {{ form.errors.email }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="flex-row">
                    <Recaptcha v-if="!user.user_id" ref="recaptcha" v-model="form.captchaResponse" theme="light" />
                </div>
                <div class="flex-row justify-end">
                    <RothcoCta class="primary" :disabled="form.hasErrors || form.processing" type="submit">
                        View Order Status
                    </RothcoCta>
                </div>
            </form>
        </div>
    </div>
</template>